<script setup lang="ts">

import Skeleton from 'primevue/skeleton'
</script>

<template>
<div class="brands-skeleton__wrapper">
  <div class="brands-skeleton_header__wrapper">
    <div class="brands-skeleton_header__wrapper_right">
      <Skeleton width="840px" height="40px" borderRadius="40px"></Skeleton>
    </div>
    <div class="brands-skeleton_header__wrapper_left">
      <Skeleton shape="circle" size="4rem"></Skeleton>
      <Skeleton shape="circle" size="4rem"></Skeleton>
    </div>
  </div>
  <div class="brands-skeleton_content__wrapper">
    <Skeleton width="200px" height="240px" borderRadius="40px"></Skeleton>
    <Skeleton width="200px" height="240px" borderRadius="40px"></Skeleton>
    <Skeleton width="200px" height="240px" borderRadius="40px"></Skeleton>
    <Skeleton width="200px" height="240px" borderRadius="40px"></Skeleton>
    <Skeleton width="200px" height="240px" borderRadius="40px"></Skeleton>
    <Skeleton width="200px" height="240px" borderRadius="40px"></Skeleton>
  </div>
</div>
</template>

<style scoped>
.brands-skeleton__wrapper {
  display: flex;
  flex-direction: column;
  gap:40px;
  align-items: center;
  overflow: hidden;
}

.brands-skeleton_header__wrapper {
  display: flex;
  justify-content: space-between;
  width: 80%;
}

.brands-skeleton_content__wrapper {
  display: flex;
  gap:10px;
}

.brands-skeleton_header__wrapper_left {
  display: flex;
  gap:10px
}

</style>